export default __webpack_public_path__ + "static/media/spice.c3707fd5.jpg";